<script>
    import Select from "svelte-select";
    import { getGroups, paginateGroupByUser } from "../../services/groupService";
    import { groupTypeByAncestorCount } from "../../utils/subscribers";

    async function searchGroupByName(filterText) {
        if (!filterText) { return [] }

        const params = { page: 1, size: 50, name: filterText, ...(groupType ? { groupType } : {}) }

        await (isUserBased ? paginateGroupByUser({ ...params, bestMatch: true }) : getGroups(params)).then((data) => {
            groups = data?.data?.data.map((group) => ({
                label: `${group.name}${isUserBased ? ` - ${groupTypeByAncestorCount.find(g => g.match(group.ancestorsCount)).value}` : ''}`,
                value: group.id,
                ancestorsCount: group.ancestorsCount
            }));
        });

        return groups;
    }

    export let groups = [];
    export let value = "";
    export let required = true;
    export let isForm = true;
    export let isUserBased = false;
    export let groupType = undefined;
    export let placeholder = "Nome del gruppo";
</script>


<Select
    {groups}
    id="groupId"
    maxlength="200"
    type= "text"
    {placeholder}
    debounceWait={300}
    bind:value={value}
    loadOptions={searchGroupByName}
    class="rounded"
    required={required}
    containerStyles={`
        border: 1px solid #e0e0e0;
        border-radius: 0px;
        height: 2.75rem;
    ` + (isForm ? 'box-shadow: 0px 1px 4px 0px rgb(0 0 0 / 15%);' : '')}
    on:clear
    on:change
>
    <div slot="empty" class="flex justify-center py-3">Digita il nome di un gruppo</div>
</Select>